import React, { useState, useEffect, useCallback, useContext } from "react";
import ReactPaginate from "react-paginate";
import Product from "../../home/Products/Product";
import { paginationlog, loadLogistic,paginationMetalog,loadEventos} from "../../../constants/logistica";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import LogTable from "./LogTable";
import debounce from "lodash.debounce"; // Asegúrate de instalar lodash.debounce
import { UserConfigContext } from "../../../context/UserConfigContext";

const Items = ({ products, viewType, hoveredItem, setHoveredItem }) => {
  const [quantities, setQuantities] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();


  if (products.length === 0) {
    return (
      <div className="text-center text-lg text-gray-600 mt-8">
        No se encontraron resultados.
      </div>
    );
  }
  
  return viewType === "table" ? (
    <LogTable
      products={products}
    />
  ) : (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10 mdl:gap-4 lg:gap-10">
   
    </div>
  );

  
};

const PaginationLog = () => {
  const today = new Date();
  const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

  const [products, setProducts] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [viewType, setViewType] = useState("table");
  const [hoveredItem, setHoveredItem] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [fecha_desde, setfechadesde] = useState(formattedDate); // fecha actual por defecto
  const [fecha_hasta, setfechahasta] = useState(formattedDate); // fecha actual por defecto
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedType, setSelectedType] = useState("0");
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const handleSearchTermChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  const handleSelectChange = (setter, key) => (e) => {
    const value = e.target.value;
    setter(value); 
    setPageNumber(1);
  };

  const getLoadFunction = () => {
    const path = location.pathname;
    return loadLogistic;
  };

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const loadFunction = getLoadFunction();
      await loadFunction(pageNumber, selectedType, itemsPerPage,searchTerm,fecha_desde, fecha_hasta);
      const data = paginationlog;
      setProducts(data);
    } catch (error) {
      console.error("Error loading products:", error);
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetchProducts = useCallback(
    debounce(fetchProducts, 500),
    [pageNumber,  selectedType,itemsPerPage,searchTerm, fecha_desde, fecha_hasta]
  );

  useEffect(() => {
    debouncedFetchProducts();
    return () => {
      debouncedFetchProducts.cancel();
    };
  }, [debouncedFetchProducts]);

  // ✅ Nuevo useEffect para cargar eventos al montar
useEffect(() => {
  const fetchEventos = async () => {
    try {
      const data = await loadEventos(); // Asegurate que loadEventos esté importado
      setEventos(data);
    } catch (error) {
      console.error("Error cargando eventos:", error);
    }
  };

  fetchEventos();
}, []);

  const pageCount = paginationMetalog.totalPages;
  
  return (
    <div className="p-5">
      <div className="flex mb-4 items-end gap-4 flex-wrap">
      <input
          type="text"
          placeholder="Buscar productos..."
          value={searchTerm}
          onChange={handleSearchTermChange}
          className="flex-grow border border-gray-300 rounded p-2"
        />
        <select value={itemsPerPage} onChange={(e) => setItemsPerPage(Number(e.target.value))} className="ml-2 border border-gray-300 rounded p-2">
          <option value={50}>50</option>
          <option value={75}>75</option>
          <option value={100}>100</option>
          <option value={-1}>Todos</option>
        </select>
      </div>

      <div className="flex flex-wrap gap-4 mb-4">

  {/* Fecha Desde */}
  <div className="flex-1 min-w-[200px]">
    <label className="block text-sm text-gray-700 mb-1">Fecha Desde</label>
    <input
      type="date"
      value={fecha_desde || ""}
      onChange={(e) => setfechadesde(e.target.value)}
      className="border border-gray-300 rounded p-2 w-full"
    />
  </div>

  {/* Fecha Hasta */}
  <div className="flex-1 min-w-[200px]">
    <label className="block text-sm text-gray-700 mb-1">Fecha Hasta</label>
    <input
      type="date"
      value={fecha_hasta || ""}
      onChange={(e) => setfechahasta(e.target.value)}
      className="border border-gray-300 rounded p-2 w-full"
    />
  </div>

   {/* Selector de condición */}
   <div className="flex-1 min-w-[200px]">
  <label className="block text-sm text-gray-700 mb-1">Evento</label>

  <select
    value={selectedType}
    onChange={handleSelectChange(setSelectedType, "selectedType")}
    className="border border-gray-300 rounded p-2 w-full"
    onMouseOver={(e) => {
      const value = e.target.value;
      const evento = eventos.find(ev => ev.id.toString() === value);
      if (evento?.observaciones) {
        e.target.title = evento.observaciones;
      }
    }}
  >
    <option value="0">Seleccionar Evento</option>
    {eventos.map((evento) => (
      <option
        key={evento.id}
        value={evento.id}
        title={evento.observaciones} // Esto NO funciona en la mayoría de navegadores
      >
        {evento.descripcion}
      </option>
    ))}
  </select>

  {selectedType !== "0" && (
    <div className="text-xs text-gray-500 mt-1">
      {eventos.find(e => e.id.toString() === selectedType)?.observaciones}
    </div>
  )}
</div>



</div>

      {loading ? (
        <div className="text-center text-xl my-4">Cargando...</div>
      ) : (
        <Items products={products} viewType={viewType} hoveredItem={hoveredItem} setHoveredItem={setHoveredItem} />
      )}

      {pageCount > 1 && (
        <ReactPaginate
          nextLabel="Siguiente"
          onPageChange={(e) => {
            const newPageNumber = e.selected + 1;
            setPageNumber(newPageNumber);
            sessionStorage.setItem("pageNumber", newPageNumber);
          }}
          pageCount={pageCount}
          forcePage={pageNumber - 1}
          previousLabel="Anterior"
          pageClassName="page-item mx-1 rounded-full text-gray-700 border border-gray-300 hover:bg-blue-100"
          pageLinkClassName="page-link px-3 py-1"
          previousClassName="page-item mx-1 rounded-full text-gray-700 border border-gray-300 hover:bg-blue-100"
          previousLinkClassName="page-link px-3 py-1"
          nextClassName="page-item mx-1 rounded-full text-gray-700 border border-gray-300 hover:bg-blue-100"
          nextLinkClassName="page-link px-3 py-1"
          breakLabel="..."
          breakClassName="page-item mx-1"
          breakLinkClassName="page-link px-3 py-1"
          containerClassName="pagination flex justify-center items-center mt-8"
          activeClassName="bg-blue-500 text-white rounded-full"
        />
      )}
    </div>
  );
};

export default PaginationLog;
